// Layout for the coverage surfaces (bead hf-e6-commitments-coverage-udt.6).
//
// CSS-only, like every other feature stylesheet here — no JavaScript width branching,
// so the week renders identically in a test as on a phone.
//
// The week is a single column until the week surface itself is wide enough for seven
// tracks. This is deliberately a container query: browser zoom can leave a desktop
// viewport media query matched while cutting the component's usable width in half.
// A day keeps its heading and its needs together in both shapes, because the failure
// mode of a narrow week strip is a column of chips whose day you can no longer see.
export const coverageStylesheet = `
.coverage-chip { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); margin: 0; }
.coverage-chip__count { color: var(--color-ink-muted, #5b6862); }

.coverage-pending-ask { display: block; }

.coverage-health { display: grid; gap: var(--space-8, 0.5rem); }
.coverage-health p { margin: 0; }
.coverage-health__tally { display: flex; flex-wrap: wrap; gap: var(--space-16, 1rem);
  list-style: none; margin: 0; padding: 0; color: var(--color-ink-muted, #5b6862); }

.coverage-week { container-type: inline-size; display: grid;
  gap: var(--space-12, 0.75rem); min-width: 0; }
.coverage-week__heading { margin: 0; }
/* Moving between weeks (bead hf-rtf). The controls wrap rather than scroll: on a
   360px phone three buttons on one line would each be too small to hit. */
.coverage-week__nav { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  margin-block: var(--space-8, 0.5rem); }
.coverage-week__days { display: grid; gap: var(--space-12, 0.75rem); min-width: 0;
  list-style: none; margin: 0; padding: 0; }

.coverage-day { display: grid; gap: var(--space-8, 0.5rem);
  border: 1px solid var(--color-border, #d7ded9); border-radius: var(--radius-8, 0.5rem);
  padding: var(--space-12, 0.75rem); background: var(--color-surface, #ffffff); }
.coverage-day__heading { margin: 0; font-size: var(--font-size-14, 0.875rem); }
.coverage-day__empty { margin: 0; color: var(--color-ink-muted, #5b6862); }
.coverage-day__needs, .coverage-attention__list { display: grid; gap: var(--space-12, 0.75rem);
  list-style: none; margin: 0; padding: 0; }

.coverage-need { display: grid; gap: var(--space-4, 0.25rem); }
.coverage-need__label { margin: 0; font-weight: 600; }
.coverage-need__window { margin: 0; color: var(--color-ink-muted, #5b6862); }

.coverage-attention { display: grid; gap: var(--space-12, 0.75rem); }
.coverage-attention h2 { margin: 0; }

/* Seven tracks need roughly 64px each after gaps. Below that, one readable column
   is preferable to seven internally overflowing tracks. */
@container (min-width: 32rem) {
  .coverage-week__days { grid-template-columns: repeat(7, minmax(0, 1fr)); align-items: start; }
}
`;
